import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsArchlinuxComponent } from './simple-icons-archlinux.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsArchlinuxComponent ],
    exports:      [ SimpleIconsArchlinuxComponent ],
    bootstrap:    []
})
export class SimpleIconsArchlinuxModule {}
